import React, {Fragment, useState} from 'react';
import ListDropDown from './ListDropDown';
import ListDropDownMobile from './ListDropDownMobile';
import UseHeaderQuery from '@staticQueries/headerQuery';

export default function NavDesktop({ }) {
    const kontentQuery = UseHeaderQuery();
    const [mobileMenuOpen, openCloseMenu] = useState(false);
    const [fsMenuOpen, openCloseFsMenu] = useState(false);
    const [rsMenuOpen, openCloseRsMenu] = useState(false);
    /*const [fsMobileMenuOpen, openCloseFsMobileMenu] = useState(false);
    const [rsMobileMenuOpen, openCloseRsMobileMenu] = useState(false);*/

    const openFsMenu = () => {
        openCloseFsMenu(true);
        if (typeof document !== `undefined`) {
            var fsMenu = document.getElementById("fs-menu");
        }

        fsMenu.classList.add("show");
    }

    const closeFsMenu = () => {
        openCloseFsMenu(false);
        if (typeof document !== `undefined`) {
            var fsMenu = document.getElementById("fs-menu");
        }

        fsMenu.classList.remove("show");
    }   

    const openRsMenu = () => {
        openCloseRsMenu(true);

        if (typeof document !== `undefined`) {
            var rsMenu = document.getElementById("rs-menu");
        }

        rsMenu.classList.add("show");
    }

    const closeRsMenu = () => {
        openCloseRsMenu(false);
        if (typeof document !== `undefined`) {
            var rsMenu = document.getElementById("rs-menu");
        }

        rsMenu.classList.remove("show");
    }

    const closeOpenMenus = (e) => {
        // ignore if selecting from dropdown menu item
       if(e.target.className === 'dropdown-item') {
            return;
        }

        if (typeof document !== `undefined`) {
            var fsMenu = document.getElementById("fs-menu");
            var rsMenu = document.getElementById("rs-menu");
        }

        openCloseFsMenu(false);
        openCloseRsMenu(false);

        fsMenu.classList.remove("show");
        rsMenu.classList.remove("show");
    }

    if (typeof document !== `undefined`) {
        document.addEventListener('mousedown', closeOpenMenus);
    }

    const openMobileMenu = () => {
        openCloseMenu(true);
    }

    const closeMobileMenu = () => {
        if (typeof document !== `undefined`) {
            openCloseMenu(false);
            const navMobile = document.getElementById("checksmart-mobile-menu");
            setTimeout(() => {
                navMobile.classList.add("collapsing");
            }, 100);
            setTimeout(() => {
                navMobile.classList.remove("show");
            }, 400);
        }
    }

    const openMobileList = (e, name) =>{
        if (typeof document !== `undefined`) {             
            const menu = document.getElementById(name);
            if(menu.classList.contains('collapsed')){
                menu.classList.remove("collapsed");
                menu.classList.add("show");
                e.target.classList.add("show");                
            }
            else{
                e.target.classList.remove("show");
                menu.classList.remove("show");                
                menu.classList.add("collapsed");
            }
        }
    }

    const filteredData = (category_name, other_category = "dropdown") => {
        const filtered = kontent_menu.filter( (item) => {
        return item.elements.footer_menu_links__footer_menu_type.value.some(category => (category.codename === category_name || category.codename === other_category  ));
        })
        return filtered;
    };
    const kontent = kontentQuery;
    const kontent_menu = kontent.main_menu.modular_content;
    const kontent_menu_normal = filteredData("normal", "dropdown");
    const kontent_menu_icons = filteredData("icon", "button");
    const kontent_menu_financial = kontent.menu_financial_services.modular_content;
    const kontent_menu_resources = kontent.menu_about_us.modular_content;


  return (
    
    <Fragment>
        <nav id="cic-header-nav-container" className="bg-blue" >
            <div className="cic-header-wrapper  d-flex flex-row justify-content-between align-items-center">
                <div id="normal-site-logo" className="site-logo cic-header-nav-logo d-flex">
                    <div className="cic-header-hamburger">
                        <button id="normal-cic-controls" type="button" data-bs-toggle="collapse" data-bs-target="#checksmart-mobile-menu" aria-controls="checksmart-mobile-menu" aria-expanded="false" aria-label="Toggle navigation" 
                                style={{border: "none", background: "rgb(255 255 255 / 0%)"}}>	
                                { !mobileMenuOpen 
                                    ? <div className="IconHamburger cic-icon-hamburger cic-icon-white" onClick={openMobileMenu}></div>
                                    : <div className="IconCloseMenu cic-icon-white" onClick={closeMobileMenu}></div>                                    
                                }				                                                        
                        </button>
                    </div>
                    <a 
                        href="/" 
                        title="Home" 
                        className="d-flex cic-tag-global-nav"
                        data-menu={`NAV LOGO`}
                        data-target="NAV"
                    >
                        <img 
                            width={kontent.logo.value[0].width} 
                            height={kontent.logo.value[0].height} 
                            src={kontent.logo.value[0].url}
                            alt={`Logo - ${process.env.GATSBY_BRAND}`}
                            title={`Logo - ${process.env.GATSBY_BRAND}`}
                            className="entered" 
                        />
                    </a>
                </div>
                <div id="tablet-apply-now-button">
                    <a style={{width: "10em "}} href={`${process.env.GATSBY_APPLY}`} title="Find a Store" className="cic-btn cic-btn-primary" aria-label=""><span className="cic-caption--bold-header ">Find a Store</span></a>
                </div>
                <div id="cic-normal-mobile-nav" className="d-flex flex-row align-items-center">
                    <div className="cic-header-nav-icon">
                        
                        <a 
                            className="cic-header-nav-login-link cic-tag-global-nav"
                            data-menu={`NAV MOB Login`}
                            data-target="NAV"
                            title="Click here to log into your account"
                            aria-label="Click here to log into your account"
                            href="https://cccs.ccfi.com/"
                            target="_blank"
                            rel="noopener noreferrer" 
                        >
                            <div className="mm-icon-wrapper IconUser cic-icon-quaternary"></div>
                        </a>
                    </div>
                </div>
                <div id="cic-desktop-nav">
                    <ul className="d-flex flex-row justify-content-start align-items-center" role="menu">
                        {
                            kontent_menu_normal.map((menu) => {
                                if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "normal"){
                                    return(
                                        <li key={menu.id} className="cic-nav-item cic-paragraph--medium" data-menu-id={menu.elements.footer_menu_links__footer_menu_label_name.value} role="menuitem">
                                            <a 
                                                data-toggle="collapse"
                                                className="cic-tag-global-nav"
                                                data-menu={`NAV ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                                data-target="NAV"
                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                href={menu.elements.footer_menu_links__footer_menu_link.value}
                                                aria-expanded="false" 
                                            >
                                                {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                            </a>
                                        </li> 
                                    )
                                }
                                else if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "dropdown" && menu.elements.footer_menu_links__footer_menu_label_name.value === "Financial Services" ){
                                    return(
                                        <li key={menu.id} className="cic-nav-item dropdown cic-paragraph--medium" data-menu-id="#Financial-Services" role="menuitem">
                                            {
                                                !fsMenuOpen
                                                    ?
                                                        (
                                                            <a 
                                                                aria-haspopup="true" 
                                                                role="button" 
                                                                className="nav-link" 
                                                                data-toggle="dropdown" 
                                                                href="#" 
                                                                aria-expanded="false" 
                                                                onClick={openFsMenu}
                                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                            >
                                                                {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                                            </a>
                                                        )
                                                    :
                                                    (
                                                        <a 
                                                            aria-haspopup="true" 
                                                            role="button" 
                                                            className="nav-link" 
                                                            data-toggle="dropdown" 
                                                            href="#" 
                                                            aria-expanded="false" 
                                                            onClick={closeFsMenu}
                                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                        >
                                                            {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                                        </a>
                                                    )
                                            }
                                            <div id="fs-menu" className="simple-dropdown-menu dropdown-menu">
                                                <ListDropDown menu_drop={kontent_menu_financial} />
                                            </div>
                                        </li>
                                    )
                                }
                                else if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "dropdown" && menu.elements.footer_menu_links__footer_menu_label_name.value === "Resources" ){
                                    return(
                                        <li key={menu.id} className="cic-nav-item dropdown cic-paragraph--medium" data-menu-id="#Resources" role="menuitem">
                                            {
                                                !rsMenuOpen
                                                    ?
                                                        (
                                                            <a aria-haspopup="true" role="button" className="nav-link" data-toggle="dropdown" href="#" aria-expanded="false" onClick={openRsMenu}
                                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                            >
                                                                {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                                            </a>
                                                        )
                                                    :
                                                    (
                                                        <a aria-haspopup="true" role="button" className="nav-link" data-toggle="dropdown" href="#" aria-expanded="false"  onClick={closeRsMenu}
                                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                        >
                                                            {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                                        </a> 
                                                    ) 
                                            }
                                            <div id="rs-menu" className="simple-dropdown-menu dropdown-menu">
                                                <ListDropDown menu_drop={kontent_menu_resources} />
                                            </div>
                                        </li>
                                    )
                                }
                            })
                        }
                    </ul>
                    <div id="cic-utilities-container" className="d-flex">
                        {
                            kontent_menu_icons.map((menu) => {
                                if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "icon"  ){
                                    return(
                                        <div key={menu.id}  className="d-flex flex-row align-items-center cic-nav-login">
                                            <a 
                                                className="cic-header-nav-login-link cic-tag-global-nav"
                                                data-menu={`NAV ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                                data-target="NAV"
                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                href={menu.elements.footer_menu_links__footer_menu_link.value}
                                                target="_blank"
                                                rel="noopener noreferrer" 
                                            >
                                                <div className="mm-icon-wrapper IconUser cic-icon-quaternary"></div>
                                                <p className="cic-paragraph--medium">{menu.elements.footer_menu_links__footer_menu_label_name.value}</p>
                                            </a>
                                        </div>
                                    )
                                }
                                return(
                                        <div key={menu.id} className="d-flex align-items-center cic-nav-btn-container">
                                            <a 
                                                className="btn-header cic-btn-icon cic-caption--medium cic-tag-global-nav"
                                                data-menu={`NAV ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                                data-target="NAV"
                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                href={menu.elements.footer_menu_links__footer_menu_link.value}
                                            >
                                                <img 
                                                    className='target-icon' 
                                                    src="https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/4336d85b-080a-474d-b2a7-c8839752905c/map-marker.svg" 
                                                    alt="Target Icon" 
                                                /> <span className="cic-caption--bold-header ">{menu.elements.footer_menu_links__footer_menu_label_name.value}</span>
                                            </a>
                                        </div> 
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            
            <div className="collapse navbar-collapse" id="checksmart-mobile-menu">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 mobile-list" role="menu">
                    {
                        kontent_menu_normal.map((menu) => {
                            if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "normal"){
                                return(
                                    <li key={`mobile-${menu.id}`} className="cic-nav-item cic-paragraph--medium cic-nav-white" role="menuitem">
                                        <a 
                                            className="cic-tag-global-nav"
                                            data-menu={`NAV MOB ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                            data-target="NAV"
                                            data-toggle="collapse" 
                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            href={menu.elements.footer_menu_links__footer_menu_link.value}
                                            aria-expanded="false" 
                                        >
                                            {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                        </a>
                                    </li>
                                )
                            }
                            else if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "dropdown" && menu.elements.footer_menu_links__footer_menu_label_name.value === "Financial Services" ){
                                return(
                                    <li key={`mobile-${menu.id}`} className="cic-nav-item cic-paragraph--medium cic-nav-white" role="menuitem">
                                        <a
                                            className="mobile-nav-dropdown cic-tag-global-nav"
                                            data-menu={`NAV MOB ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                            data-target="NAV"
                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            href={menu.elements.footer_menu_links__footer_menu_link.value}
                                            data-toggle="collapse"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            onClick={ (e) => openMobileList(e, "CAHeader-financial-services")}
                                        >
                                            {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                            <div className="cic-nav-drawer-icon">
                                                <div className="arrowMenu cic-arrow-menu-mob cic-icon-primary"></div>
                                            </div>
                                        </a>
                                        <div id="CAHeader-financial-services" className="panel-collapse collapse collapsed">
                                            <div className="d-flex flex-column align-items-center ml-2">
                                                <ListDropDownMobile menu_drop={kontent_menu_financial} />
                                            </div>
                                        </div>
                                    </li>
                                )
                            }
                            else if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "dropdown" && menu.elements.footer_menu_links__footer_menu_label_name.value === "Resources" ){
                                return(
                                    <li key={`mobile-${menu.id}`} className="cic-nav-item cic-paragraph--medium cic-nav-white" role="menuitem">
                                        <a 
                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            href={menu.elements.footer_menu_links__footer_menu_link.value}
                                            data-toggle="collapse"
                                            className="mobile-nav-dropdown cic-tag-global-nav" 
                                            data-menu={`NAV MOB ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                            data-target="NAV"
                                            aria-haspopup="true" 
                                            aria-expanded="false"
                                            onClick={ (e) => openMobileList(e, "CAHeader-resources")} 
                                        >
                                        {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                            <div className="cic-nav-drawer-icon">
                                                <div className="arrowMenu cic-arrow-menu-mob cic-icon-primary"></div>
                                            </div>
                                        </a>                      
                                        <div id="CAHeader-resources" className="panel-collapse collapse collapsed">
                                            <div className="d-flex flex-column align-items-center ml-2">
                                                <ListDropDownMobile menu_drop={kontent_menu_resources} />
                                            </div>
                                        </div>
                                    </li>
                                )
                            }
                        })
                    }
                    <Fragment>
                        {
                            kontent_menu_icons.map((menu) => {
                                if(menu.elements.footer_menu_links__footer_menu_type.value[0].codename === "icon"  ){
                                    return(
                                        <li key={`mobile-${menu.id}`}  className="cic-nav-item cic-paragraph--medium cic-nav-white" role="menuitem">
                                            <a 
                                                className="cic-tag-global-nav"
                                                data-menu={`NAV MOB ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                                data-target="NAV"
                                                title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                href={menu.elements.footer_menu_links__footer_menu_link.value}
                                                aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                                target="_blank"
                                                rel="noopener noreferrer" 
                                            >
                                                <div className="mm-icon-wrapper IconUser cic-icon-secondary cic-icon-white"></div> {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                            </a>
                                        </li>
                                    )
                                }
                                return(
                                    <li key={`mobile-${menu.id}`} className="cic-nav-login cic-paragraph--medium no-border cic-nav-white" role="menuitem">
                                        <a
                                            className="d-flex align-center btn-header cic-btn-icon cic-caption--medium small-gap cic-tag-global-nav"
                                            data-menu={`NAV MOB ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                                            data-target="NAV"
                                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                            href={menu.elements.footer_menu_links__footer_menu_link.value}
                                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                                        >
                                            <img className="target-icon" src="https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/4336d85b-080a-474d-b2a7-c8839752905c/map-marker.svg" alt="Target Icon" /> {menu.elements.footer_menu_links__footer_menu_label_name.value}
                                        </a>
                                    </li>
                                )
                            })
                        }
                    </Fragment>
                </ul>
            </div>

        </nav>
        
    </Fragment>
  )
}